import {
  faCalendar,
  faCarBurst,
  faIdCard,
  faInfoCircle,
  faTrash,
  faTrashAlt
} from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Feedback } from "@mui/icons-material"
import {
  Box,
  Chip,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Stack,
  Switch,
  Typography
} from "@mui/material"
import TextField from "@mui/material/TextField"
import { customerHasFeature } from "auth/customerHasFeature"
import { hasRole } from "auth/hasRole"
import { useApi } from "auth/useApi3"
import { AppContext } from "components/AppContextProvider"
import Button from "components/Button"
import ClpTable from "components/ClpTable"
import { MultiSelectFilter } from "components/ClpTable/ClpTableFilterTypes"
import TableButton from "components/ClpTable/components/actions/TableButton/TableButton"
import { StyledTableButtonGroup } from "components/ClpTable/components/actions/TableButton/tableButtonGroup.styled"
import { TableButtonTypeEnum } from "components/ClpTable/components/actions/TableButton/tableButtonProps.interface"
import FormPreviewFileThumbnail from "components/Form/FormComponents/FormUploadFile/FormPreviewFileThumbnail"
import FormUploadFile from "components/Form/FormComponents/FormUploadFile/FormUploadFile"
import { TabPanel } from "components/navigation/TabPanel"
import PaperBox from "components/PaperBox"
import IssueReportNotification from "components/SettingsSwitch/IssuereportNotification/IssuereportNotification"
import VtrSwitch from "components/SettingsSwitch/VtrSwitch"
import theme from "css/theme/light"
import { FieldArray, Formik } from "formik"
import { apiEndpoints } from "generated/apiEndpoints"
import { allFeatures } from "generated/features"
import { allRoles } from "generated/roles"
import { removeQueryFromImgSrc } from "pages/documents/helpers/imageSrcSasKey"
import { companyValidationSchema } from "pages/systemadmin/pages/customers/components/validationSchema"
import { useContext, useEffect, useMemo, useRef, useState } from "react"
import CrisisInfoForm from "shared/customer/CrisisInfo/CrisisInfoForm"
import { StyledPrimaryAvatar, StyledTableContainer } from "shared/styled/Global"
import * as Yup from "yup"
import DepartmentForm from "./DepartmentForm"
import Violation from "./Violation/Violation"
import DepartmentsList from "shared/customer/DepartmentList/DepartmentsList"
import { useTranslation } from "react-i18next"

export function departmentsWithListId(items) {
  return items.map((item) => {
    return {
      ...item,
      listId: item.id
    }
  })
}

function companyInitialValues(company) {
  return company
    ? company
    : {
        id: 0,
        name: "",
        organisationNumber: "",
        streetAddress: "",
        postalCode: "",
        cityAddress: "",
        hasVtrIntegration: false,
        bplUrl: null,
        logoFileId: null,
        violationEmail: null,
        bkyActive: false,
        bkyClientCredentialsUserName: "",
        bkyClientCredentialsPassword: "",
        insuranceCompanyEmailActive: false,
        insuranceCompanyEmail: [],
        bkyCheckBus: false,
        bkyCheckTaxi: false,
        bkyCheckFreight: false
      }
}

export const CompanyForm = ({
  customer,
  company,
  onSubmit,
  result,
  openRemoveDialog,
  tabValue,
  setCurrentWorkshop,
}) => {
  const appContext = useContext(AppContext)
  const [departments, setDepartments] = useState(company ? departmentsWithListId(company.departments) : [])
  const formRef = useRef()
  const editMode = company ? true : false
  const [getCrisisInfoResult, getCrisisInfoApi] = useApi()
  const [upsertCrisisInfoResult, upsertCrisisInfoApi] = useApi()
  const initialValues = companyInitialValues(company)
  const [attachmentPostResult, attachmentPostApi] = useApi()
  const [attachmentResult, attachmentApi] = useApi()
  const [deleteFileResult, deleteFile] = useApi()
  const [updateCompanyResult, updateLogoOnCompany] = useApi()
  const [violationActive, setViolationActive] = useState(false)
  const [insuranceCompanyEmailActive, setInsuranceCompanyEmailActive] = useState(false)
  const [bkyActive, setBkyActive] = useState(false)
  const [workshopsResults, workshopsApi] = useApi()
  const { t } = useTranslation()

  const handleSubmit = async (values, { resetForm, setFieldTouched }) => {
    setFieldTouched("violationEmail", true)
    const customerId = customer.id
    const companyToCreate = {
      ...values,
      customerId: customerId,
      departments: departments
    }

    onSubmit(companyToCreate)
  }
  const removeFile = () => {
    deleteFile.del(
      apiEndpoints.attachment.deleteattachment.replace(
        "{fileid}",
        formRef.current.values.logoFileId.replace("/", "%2F")
      )
    )
  }
  function openSidebar(workshop) {
    setCurrentWorkshop(workshop)
    appContext.toggleSideBar(true)
  }
  function uploadBlobFiles(uploadedFile) {
    const url = apiEndpoints.attachment.addattachment.replace("{feature}", `companies`)

    attachmentPostApi.file(url, uploadedFile[0])
  }

  useEffect(() => {
    if (attachmentPostResult.status === 2) {
      formRef.current.setFieldValue("logoFileId", attachmentPostResult.data[0].fileId)
      const feature = attachmentPostResult.data[0].fileId.split("/")[0]
      const fileId = attachmentPostResult.data[0].fileId.split("/")[1]

      const url = apiEndpoints.attachment.getattachments
        .replace("{fileid}", fileId)
        .replace("{feature}", feature)

      attachmentApi.get(url)
    }
  }, [attachmentPostResult])

  useEffect(() => {
    if (tabValue === 3) {
      const url = `${apiEndpoints.vehicleregistrychecks.getcompanycarworkshops}?companyId=${company.id}`
      workshopsApi.get(url)
    }
  }, [tabValue])

  useEffect(() => {
    const companyLogoExists = company?.logoFileId !== null && company?.logoFileId !== undefined
    if (companyLogoExists) {
      const feature = company?.logoFileId.split("/")[0]
      const fileId = company?.logoFileId.split("/")[1]

      const url = apiEndpoints.attachment.getattachments
        .replace("{fileid}", fileId)
        .replace("{feature}", feature)

      attachmentApi.get(url)
    }
  }, [company?.logoFileId])

  useEffect(() => {
    if (deleteFileResult.status === 2) {
      formRef.current.setFieldValue("logoFileId", null)

      if (initialValues.id !== 0) {
        const updateFileOnCompany = {
          ...initialValues,
          logoFileId: null
        }
        updateLogoOnCompany.put(apiEndpoints.customeradmin.updatecompany, updateFileOnCompany)
      }
    }
  }, [deleteFileResult])

  const columns = useMemo(() => {
    const baseColumns = [
      {
        accessorKey: "name",
        header: t("global.workshop", "Workshop")
      },
      {
        accessorKey: "emailAddress",
        header: t("global.email", "Email")
      },
      {
        accessorFn: (row) => {
          return row.isActive ? "yes" : "no"
        },
        cell: ({ row }) => {
          const label = row.original.isActive ? (
            <span>{t("global.yes", "Yes")}</span>
          ) : (
            <span>{t("global.no", "No")}</span>
          )
          return <>{label}</>
        },
        header: t("global.active", "Active"),
        filterFn: "arrIncludesSome",
        meta: {
          mainFilter: true,
          defaultValue: ["yes"],
          filter: MultiSelectFilter,
          filterOptions: [
            { value: "yes", name: t("global.yes", "Yes") },
            { value: "no", name: t("global.no", "No") }
          ]
        }
      }
    ]

    if (hasRole(appContext.appUser, allRoles.CustomerAdmin)) {
      baseColumns.push({
        accessorKey: "edit",
        numeric: false,
        disablePadding: true,
        header: "",
        align: "right",
        cell: ({ cell }) => (
          <StyledTableButtonGroup>
            <TableButton type={TableButtonTypeEnum.Edit} handleOnClick={() => openSidebar(cell.row.original)} />
          </StyledTableButtonGroup>
        )
      })
    }

    return baseColumns
  }, [appContext.appUser, openSidebar, t])

  const workshopInitialFilters = [
    {
      id: "isActive",
      value: "yes"
    }
  ]

  const [validationStep, setValidationStep] = useState(companyValidationSchema(t))

  useEffect(() => {
    setViolationActive(initialValues.violationActive)
    setBkyActive(initialValues.bkyActive)
    setInsuranceCompanyEmailActive(initialValues.insuranceCompanyEmailActive)
  }, [])

  const combineValidationSchema = () => {
    let combinedValidationSchema = companyValidationSchema(t)

    if (violationActive) {
      const violationObj = {
        violationEmail: Yup.string().nullable().required(t("global.email_is_required", "Email is required"))
      }
      combinedValidationSchema = combinedValidationSchema.concat(Yup.object().shape(violationObj))
    } else {
      const violationObj = {
        violationEmail: Yup.string().nullable()
      }
      combinedValidationSchema = combinedValidationSchema.concat(Yup.object().shape(violationObj))
    }

    if (bkyActive) {
      const bkyObj = {
        bkyClientCredentialsUserName: Yup.string()
          .nullable()
          .required(t("global.name_is_required", "Name is required")),
        bkyClientCredentialsPassword: Yup.string()
          .nullable()
          .required(t("global.password_is_required", "Password is required"))
      }
      combinedValidationSchema = combinedValidationSchema.concat(Yup.object().shape(bkyObj))
    } else {
      const bkyObj = {
        bkyClientCredentialsUserName: Yup.string().nullable(),
        bkyClientCredentialsPassword: Yup.string().nullable()
      }
      combinedValidationSchema = combinedValidationSchema.concat(Yup.object().shape(bkyObj))
    }

    if (insuranceCompanyEmailActive) {
      const insuranceObj = {
        insuranceCompanyEmail: Yup.array()
          .of(
            Yup.string()
              .trim()
              .email(t("global.must_be_a_valid_email", "Must be a valid email"))
              .required(t("global.email_is_required", "Email is required"))
          )
          .min(1, t("global.email_is_required", "Email is required"))
      }
      combinedValidationSchema = combinedValidationSchema.concat(Yup.object().shape(insuranceObj))
    } else {
      const insuranceObj = {
        insuranceCompanyEmail: Yup.array()
          .nullable()
          .of(Yup.string().trim().email(t("global.must_be_a_valid_email", "Must be a valid email")))
      }
      combinedValidationSchema = combinedValidationSchema.concat(Yup.object().shape(insuranceObj))
    }

    setValidationStep(combinedValidationSchema)
  }

  useEffect(() => {
    combineValidationSchema()
  }, [violationActive, bkyActive, insuranceCompanyEmailActive])

  useEffect(() => {
    if (!company) return
    getCrisisInfoApi.get(
      apiEndpoints.crisismanagement.getcrisisinfobycompanyid.replace("{companyId}", company.id)
    )
  }, [getCrisisInfoApi])

  const handleCrisisSubmit = (formikValues) => {
    if (formikValues?.body) {
      formikValues.body = removeQueryFromImgSrc(formikValues.body)
    }
    upsertCrisisInfoApi.put(apiEndpoints.crisismanagement.upsertcrisisinfo, formikValues)
  }

  return (
    <>
      <Formik
        validateOnChange={false}
        validateOnBlur={true}
        innerRef={formRef}
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationStep}
        enableReinitialize={true}>
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
          <form id="companyForm" onSubmit={handleSubmit} noValidate>
            <TabPanel value={tabValue} index={0}>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={8}>
                  <PaperBox mt={0}>
                    <Box mb={3}>
                      <Typography fontWeight={600} variant="bodyMedium" color="textPrimary">
                        {t("global.company_information", "Company information")}
                      </Typography>
                    </Box>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={8}>
                        <TextField
                          autoComplete="off"
                          fullWidth
                          id="name"
                          label={t("global.name", "Name")}
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.name && errors.name ? true : false}
                          helperText={
                            touched.name && errors.name
                              ? t("global.name_is_required", "Name is required")
                              : null
                          }
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          autoComplete="off"
                          fullWidth
                          id="organisationNumber"
                          label={t("global.corporate_id_nr", "Organization number")}
                          value={values.organisationNumber}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.organisationNumber && errors.organisationNumber ? true : false}
                          helperText={
                            touched.organisationNumber && errors.organisationNumber
                              ? errors.organisationNumber
                              : null
                          }
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          autoComplete="off"
                          fullWidth
                          id="streetAddress"
                          label={t("global.street_address", "Street address")}
                          value={values.streetAddress}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.streetAddress && errors.streetAddress ? true : false}
                          helperText={
                            touched.streetAddress && errors.streetAddress ? errors.streetAddress : null
                          }
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          autoComplete="off"
                          fullWidth
                          id="postalCode"
                          label={t("global.postal_code", "ZIP code")}
                          value={values.postalCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.postalCode && errors.postalCode ? true : false}
                          helperText={touched.postalCode && errors.postalCode ? errors.postalCode : null}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} md={8}>
                        <TextField
                          autoComplete="off"
                          fullWidth
                          id="cityAddress"
                          label={t("global.city", "City")}
                          value={values.cityAddress}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.cityAddress && errors.cityAddress ? true : false}
                          helperText={touched.cityAddress && errors.cityAddress ? errors.cityAddress : null}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item mt={2}>
                        <Typography mb={2} variant="labelLarge" fontWeight={600} gutterBottom display="block">
                          {t("global.logo", "Logo")}
                        </Typography>
                        <FormUploadFile
                          acceptedFileFormat={{
                            "image/jpeg": [".jpg", ".jpeg"],
                            "image/svg+xml": [".svg"],
                            "image/png": [".png"]
                          }}
                          handleChange={(uploadedFiles) => {
                            uploadBlobFiles(uploadedFiles)
                          }}
                        />
                        {attachmentResult.status === 2 && values.logoFileId !== null && (
                          <FormPreviewFileThumbnail
                            Data={attachmentResult?.data?.data}
                            fileId={values?.logoFileId}
                            fileName={attachmentResult?.data?.filename}
                            removeFile={removeFile}
                          />
                        )}
                      </Grid>
                      <Grid
                        item
                        md={12}
                        display="flex"
                        direction="row"
                        justifyContent={editMode ? "space-between" : "flex-end"}
                        mt={3}
                      >
                        {editMode && (
                          <Box>
                            <Button color="primary" variant="outlined" onClick={openRemoveDialog}>
                              {t("settings.form.button.remove_company", "Remove company")}
                            </Button>
                          </Box>
                        )}
                        <Box>
                          <Button type="submit" color="primary" result={result}>
                            {t("global.save", "Save")}
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </PaperBox>
                </Grid>
                <Grid item xs={12} lg={4}>
                  {customerHasFeature(appContext?.appUser?.customer, allFeatures.VehicleRegistry) && (
                    <VtrSwitch
                      img="assets/Transportstyrelsen-icon.jpg"
                      title={t("settings.form.vtr_title", "Swedish Transport Agency")}
                      id={`hasVtrIntegration`}
                      message={t(
                        "settings.form.vtr_description",
                        "Your company has permission to import vehicles from the Swedish Transport Agency"
                      )}
                      value={values.hasVtrIntegration}
                      handleChange={() => {
                        setFieldValue(`hasVtrIntegration`, !values.hasVtrIntegration)
                      }}
                    />
                  )}
                  {customerHasFeature(appContext.appUser.customer, allFeatures.IssueReports) && (
                    <IssueReportNotification setFieldValue={setFieldValue} values={values} />
                  )}
                  {customerHasFeature(appContext.appUser.customer, "BkyChecks") && (
                    <PaperBox>
                      <Grid container direction="row" justifyContent="space-between" alignItems="center">
                        <Grid item xs={2}>
                          <Box>
                            <StyledPrimaryAvatar
                              arial-label={t("global.features.title.bkyActive", "BKY checks")}>
                              <FontAwesomeIcon icon={faIdCard} size="lg" />
                            </StyledPrimaryAvatar>
                          </Box>
                        </Grid>

                        <Grid item xs={8}>
                          <Typography variant="h5">
                            {t("global.features.title.bkyActive", "BKY checks")}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <FormControlLabel
                            label=""
                            sx={{ margin: 0 }}
                            id="bkyActive"
                            control={
                              <Switch
                                checked={values.bkyActive}
                                onChange={(e) => {
                                  setFieldValue("bkyActive", e.target.checked)
                                  setBkyActive(e.target.checked)
                                }}
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                      {values.bkyActive && (
                        <Box marginTop={2}>
                          <Divider />
                          <Grid container column marginTop={2}>
                            <Grid item xs={12}>
                              <TextField
                                fullWidth
                                id="bkyClientCredentialsUserName"
                                label={t("settings.form.username_for_bky_checks", "Username for BKY checks")}
                                value={values.bkyClientCredentialsUserName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={
                                  touched.bkyClientCredentialsUserName && errors.bkyClientCredentialsUserName
                                    ? true
                                    : false
                                }
                                helperText={
                                  touched.bkyClientCredentialsUserName && errors.bkyClientCredentialsUserName
                                    ? errors.bkyClientCredentialsUserName
                                    : null
                                }
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs={12} marginTop={2}>
                              <TextField
                                fullWidth
                                id="bkyClientCredentialsPassword"
                                label={t("settings.form.password_for_bky_checks", "Password for BKY checks")}
                                value={values.bkyClientCredentialsPassword}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={
                                  touched.bkyClientCredentialsPassword && errors.bkyClientCredentialsPassword
                                    ? true
                                    : false
                                }
                                helperText={
                                  touched.bkyClientCredentialsPassword && errors.bkyClientCredentialsPassword
                                    ? errors.bkyClientCredentialsPassword
                                    : null
                                }
                                variant="outlined"
                              />
                            </Grid>
                          </Grid>
                          <Grid item xs={8} marginTop={2}>
                            <Typography variant="h6">Aktiva kategorier</Typography>
                          </Grid>
                          <Stack spacing={1}>
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                              <Typography>Buss</Typography>
                              <FormControlLabel
                                label=""
                                sx={{ margin: 0, ml: "auto" }}
                                id="bkyCheckBus"
                                control={
                                  <Switch
                                    checked={values.bkyCheckBus}
                                    onChange={(e) => {
                                      setFieldValue("bkyCheckBus", e.target.checked)
                                    }}
                                  />
                                }
                              />
                            </Box>

                            <Box display="flex" alignItems="center" justifyContent="space-between">
                              <Typography>Taxi</Typography>
                              <FormControlLabel
                                label=""
                                sx={{ margin: 0, ml: "auto" }}
                                id="bkyCheckTaxi"
                                control={
                                  <Switch
                                    checked={values.bkyCheckTaxi}
                                    onChange={(e) => {
                                      setFieldValue("bkyCheckTaxi", e.target.checked)
                                    }}
                                  />
                                }
                              />
                            </Box>
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                              sx={{ width: "100%" }}>
                              <Typography>Gods</Typography>
                              <FormControlLabel
                                label=""
                                sx={{ margin: 0, ml: "auto" }}
                                id="bkyCheckFreight"
                                control={
                                  <Switch
                                    checked={values.bkyCheckFreight}
                                    onChange={(e) => {
                                      setFieldValue("bkyCheckFreight", e.target.checked)
                                    }}
                                  />
                                }
                              />
                            </Box>
                          </Stack>
                        </Box>
                      )}
                    </PaperBox>
                  )}
                  {customerHasFeature(appContext.appUser.customer, "Deviation") && (
                    <PaperBox>
                      <Grid container direction="row" justifyContent="space-between" alignItems="center">
                        <Grid item xs={2}>
                          <Box>
                            <StyledPrimaryAvatar
                              arial-label={t(
                                "settings.form.recipient_address_to_insurance_company",
                                "Email recipient for insurance companies"
                              )}>
                              <FontAwesomeIcon icon={faCarBurst} size="lg" />
                            </StyledPrimaryAvatar>
                          </Box>
                        </Grid>

                        <Grid item xs={8}>
                          <Typography variant="h5">
                            {t(
                              "settings.form.recipient_address_to_insurance_company",
                              "Email recipient for insurance companies"
                            )}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <FormControlLabel
                            label=""
                            sx={{ margin: 0 }}
                            id="insuranceCompanyEmailActive"
                            control={
                              <Switch
                                checked={values.insuranceCompanyEmailActive}
                                onChange={(e) => {
                                  setFieldValue("insuranceCompanyEmailActive", e.target.checked)
                                  setInsuranceCompanyEmailActive(e.target.checked)
                                }}
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                      {values.insuranceCompanyEmailActive && (
                        <Box marginTop={2}>
                          <Divider />
                          <Grid container column marginTop={2}>
                            <Grid item xs={12} display="flex" flexDirection="column" gap={3}>
                              <FieldArray
                                name="insuranceCompanyEmail"
                                render={(arrayHelpers) => {
                                  if (values.insuranceCompanyEmail.length === 0) {
                                    arrayHelpers.push("")
                                  }

                                  return (
                                    <>
                                      {values.insuranceCompanyEmail.map((email, index) => (
                                        <Box
                                          key={index}
                                          display="flex"
                                          justifyContent="space-between"
                                          alignItems="center"
                                          gap={1}>
                                          <TextField
                                            fullWidth
                                            name={`insuranceCompanyEmail[${index}]`}
                                            label={t(
                                              "settings.form.email_for_insurance_company",
                                              "Email for insurance company"
                                            )}
                                            value={email}
                                            onChange={(e) =>
                                              setFieldValue(`insuranceCompanyEmail[${index}]`, e.target.value)
                                            }
                                            onBlur={handleBlur}
                                            error={
                                              touched.insuranceCompanyEmail &&
                                              errors.insuranceCompanyEmail &&
                                              errors.insuranceCompanyEmail[index]
                                            }
                                            helperText={
                                              touched.insuranceCompanyEmail &&
                                              errors.insuranceCompanyEmail &&
                                              errors.insuranceCompanyEmail[index]
                                            }
                                            variant="outlined"
                                          />

                                          <IconButton
                                            sx={{ height: 40, width: 40 }}
                                            color="error"
                                            size="small"
                                            onClick={() => arrayHelpers.remove(index)}
                                            disabled={values.insuranceCompanyEmail.length === 1}>
                                            <FontAwesomeIcon icon={faTrashAlt} />
                                          </IconButton>
                                        </Box>
                                      ))}

                                      <Grid item xs={12} display="flex" justifyContent="flex-end">
                                        <Button
                                          variant="outlined"
                                          onClick={() => arrayHelpers.push("")}
                                          sx={{ marginTop: 1 }}>
                                          {t("global.add_email", "Add email")}
                                        </Button>
                                      </Grid>
                                    </>
                                  )
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Box>
                      )}
                    </PaperBox>
                  )}
                  {customerHasFeature(appContext?.appUser?.customer, allFeatures.Planning) && (
                    <PaperBox>
                      <Grid container direction="row" justifyContent="space-between" alignItems="center">
                        <Grid item xs={2}>
                          <Box>
                            <StyledPrimaryAvatar aria-label="BPL Integration">
                              <FontAwesomeIcon icon={faCalendar} size="lg" />
                            </StyledPrimaryAvatar>
                          </Box>
                        </Grid>

                        <Grid item xs={6}>
                          <Typography variant="h5">
                            {t("settings.form.bpl_integration", "BPL integration")}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Chip
                            color={values.bplUrl !== null ? "success" : "error"}
                            label={
                              values.bplUrl !== null
                                ? t("global.activated", "Activated")
                                : t("global.not_actived", "Not activated")
                            }
                          />
                        </Grid>
                      </Grid>
                      {values.bplUrl !== null ? (
                        <Box marginTop={2}>
                          <Divider />
                          <Box marginY={2}>
                            <Grid
                              container
                              direction="row"
                              spacing={2}
                              justifyContent="space-between"
                              alignItems="center">
                              <Grid item xs={8} md={8}>
                                <Typography variant="h5" marginTop={2}>
                                  {t("global.number_of_days", "Number of days")}
                                </Typography>
                                <Typography variant="bodyMedium">
                                  {t(
                                    "settings.form.number_of_days",
                                    "The number of days shows how far ahead drivers should see their assignments."
                                  )}
                                </Typography>
                              </Grid>
                              <Grid item xs={4} md={4} justifyContent="flex-end">
                                <TextField
                                  autoComplete="off"
                                  fullWidth
                                  type="number"
                                  id="bplDaysShown"
                                  placeholder="1-200"
                                  defaultValue={values.bplDaysShown ? values.bplDaysShown : 3}
                                  value={values.bplDaysShown}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={touched.bplDaysShown && errors.bplDaysShown ? true : false}
                                  helperText={
                                    touched.bplDaysShown && errors.bplDaysShown ? errors.bplDaysShown : null
                                  }
                                  variant="outlined"
                                  size="small"
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>
                      ) : (
                        <Box
                          marginY={2}
                          display="flex"
                          justifyContent="flex-start"
                          flexDirection="column"
                          bgcolor={theme.palette.primary[300]}
                          borderRadius="8px"
                          color={theme.palette.primary[800]}
                          p={2}
                          s
                          gap={1}>
                          <Box fontWeight="600">
                            <FontAwesomeIcon icon={faInfoCircle} size="1x" />{" "}
                            {t(
                              "settings.form.active_bpl_support",
                              "Contact support@cloudplanning.se to activate integration to BPL."
                            )}
                          </Box>
                        </Box>
                      )}
                    </PaperBox>
                  )}

                  {customerHasFeature(appContext?.appUser?.customer, allFeatures.Violation) && (
                    <Violation
                      values={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      setFieldValue={setFieldValue}
                    />
                  )}
                </Grid>
              </Grid>
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <PaperBox mt={0}>
                    <Box mb={3}>
                      <Typography fontWeight="600" variant="bodyMedium" color="textPrimary">
                        {t("global.departments", "Departments")}
                      </Typography>
                    </Box>
                    <DepartmentForm
                      onSubmit={(item) => {
                        setDepartments((s) => {
                          return [
                            ...s,
                            {
                              ...item,
                              id: 0,
                              companyId: editMode ? company.id : 0
                            }
                          ]
                        })
                      }}
                    />
                    <DepartmentsList
                      t={t}
                      departments={departments}
                      removeDepartment={(item) => {
                        setDepartments((s) => {
                          return s.filter((x) => x.listId !== item.listId)
                        })
                      }}
                    />
                    <Grid
                      container
                      direction="row"
                      justifyContent={editMode ? "space-between" : "flex-end"}
                      mt={3}
                    >
                      {editMode && (
                        <Box>
                          <Button color="primary" variant="outlined" onClick={openRemoveDialog}>
                            {t("settings.form.button.remove_company", "Remove company")}
                          </Button>
                        </Box>
                      )}
                      <Box>
                        <Button type="submit" color="primary" result={result}>
                          {t("global.save", "Save")}
                        </Button>
                        {/* <Button
                          color="primary"
                          onClick={() => {
                            if (formRef.current) {
                              formRef.current.handleSubmit()
                            }
                          }}
                          result={result}>
                          {t("global.save", "Save")}
                        </Button>*/}
                      </Box>
                    </Grid>
                  </PaperBox>
                </Grid>
              </Grid>
            </TabPanel>
            {workshopsResults.status === 2 && workshopsResults.data && (
              <TabPanel value={tabValue} index={3}>
                <PaperBox mt={0} p={0}>
                  <StyledTableContainer activeBg={false}>
                    <ClpTable
                      columns={columns}
                      rows={workshopsResults.status === 2 && workshopsResults.data}
                      status={workshopsResults.status}
                      loadingState={workshopsResults.status}
                      initialFilters={workshopInitialFilters}
                    />
                  </StyledTableContainer>
                </PaperBox>
              </TabPanel>
            )}
          </form>
        )}
      </Formik>
      <TabPanel value={tabValue} index={2}>
        {(getCrisisInfoResult.status === 2 || getCrisisInfoResult.status === 3) && (
          <CrisisInfoForm
            handleSubmit={handleCrisisSubmit}
            initialCrisisInfo={getCrisisInfoResult.data ? getCrisisInfoResult.data : null}
            result={upsertCrisisInfoResult}
            feedback={Feedback}
          />
        )}
      </TabPanel>
    </>
  )
}
